const imageCache = new Map<string, { url: string | undefined; timestamp: number }>();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getImageFromCidV0 = async (cidV0: string | undefined): Promise<string | undefined> => {
  if (!cidV0) return undefined;

  const cached = imageCache.get(cidV0);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.url;
  }

  try {
    const res = await fetch(`https://rpc.aboutcircles.com/profiles/get?cid=${cidV0}`);
    const { previewImageUrl } = await res.json();

    imageCache.set(cidV0, { url: previewImageUrl, timestamp: Date.now() });

    return previewImageUrl;
  } catch (_) {
    return undefined;
  }
};
